import { render } from "./SensorValue.vue?vue&type=template&id=36ca8b81&scoped=true&ts=true"
import script from "./SensorValue.vue?vue&type=script&lang=ts"
export * from "./SensorValue.vue?vue&type=script&lang=ts"

import "./SensorValue.vue?vue&type=style&index=0&id=36ca8b81&scoped=true&lang=css"

import exportComponent from "/opt/buildhome/repo/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-36ca8b81"]])

export default __exports__